
  function initializeProductLinks() {
    const productLinks = document.querySelectorAll('.related-product');
    const currentUrlHandle = window.location.pathname.split('/').pop();
    const currentProductColor = '{{ current_product_color }}';  // Assuming you have this data available on the page

    function setActiveProduct() {
      productLinks.forEach(link => {
        const isHandleMatch = link.dataset.productHandle === currentUrlHandle;
        const isColorMatch = link.dataset.productColor === currentProductColor;
        // Set 'active' class based on URL handle match or color match
        link.classList.toggle('active', isHandleMatch || isColorMatch);
      });
    }

    productLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        localStorage.setItem('activeProductHandle', this.dataset.productHandle);
        setActiveProduct();
        setTimeout(() => {
          window.location = this.href;
        }, 300);
      });
    });

    setActiveProduct();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductLinks);
  } else {
    initializeProductLinks();
  }
